import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { AdminComponent } from './pages/admin/admin.component';
import { GetStartedComponent } from './pages/get-started/get-started.component';
import { HistoryComponent } from './pages/history/history.component';
import { homeResolver } from './pages/home/home.resolver';
import { InterviewCopilotRunComponent } from './pages/interview-copilot-run/interview-copilot-run.component';
import { InterviewCopilotComponent } from './pages/interview-copilot/interview-copilot.component';
import { InterviewGoalComponent } from './pages/interview-goal/interview-goal.component';
import { InterviewResumeComponent } from './pages/interview-resume/interview-resume.component';
import { LoginComponent } from './pages/login/login.component';
import { MaintainanceComponent } from './pages/maintainance/maintainance.component';
import { MockInterviewComponent } from './pages/mock-interview/mock-interview.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { SignupComponent } from './pages/signup/signup.component';
import { TestComponent } from './pages/test/test/test.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/get-started',
  },
  {
    path: 'admin',
    component: AdminComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'test-page',
    component: TestComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'maintainance',
    component: MaintainanceComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
  },
  {
    path: 'my-account',
    component: MyAccountComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'history',
    component: HistoryComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'get-started',
    component: GetStartedComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'pricing',
    component: PricingComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  // {
  //   path: 'dashboard',
  //   component: InterviewComponent,
  //   resolve: {
  //     data: homeResolver,
  //   },
  //   canActivate: [authGuard],
  // },
  {
    path: 'target-positions',
    component: InterviewGoalComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'resume',
    component: InterviewResumeComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'interview-assistant/:id',
    component: InterviewCopilotRunComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'mock-interview',
    component: MockInterviewComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'interview',
    component: InterviewCopilotComponent,
    resolve: {
      data: homeResolver,
    },
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '' },
];
